import React, { useEffect, useRef } from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { listOfDatesByDay } from 'utils/dates';
import { filterObject } from 'utils/helpers';
import widgetRender from './bei-light';
import SliderComponent from '../FeedBackSynthesis/Slider';

function updateChart(widgetObject, dataFilteringRule) {
  widgetObject.detailProperties.dataFiltering = dataFilteringRule;

  widgetRender(widgetObject, 'updateData');
}

const ChartStrategyExec = ({ data, loading, error, id, title }) => {
  const d3svg = useRef(false);

  // json parametres de la viz
  const widgetProperties_US342 = {
    generalProperties: {
      chartType: 'spider', // barchart, pie, linechart, etc ...
      orientation: 'horizontal', // horizontal, vertical (for XY axis chart)
      direction: 'standard', // standard, opposite
      margin: { top: 60, right: 60, bottom: 80, left: 60 },
      size: { width: '80%', height: '80%' },
      minSize: { width: 200, height: 200 },
      minPlotSize: { width: 100, height: 100 },
      activeClipPath: false,
      errorMsg: 'lorem ipsum'
    },
    detailProperties: {
      dataAggregation: false,
      dimensionFields: ['investor'],
      dimensionFieldsDatatype: ['text'],
      dimensionFieldsLabel: ['investor'],
      dimensionFieldsFormat: null,
      dimensionFieldsCustomSort: [null],
      dimensionFieldsSortOrder: ['ASC'],
      calculationFields: ['strategyExecution'],
      calculationFieldsLabel: ['strategyExecution'],
      calculationFieldsDatatype: ['number'],
      calculationFieldsFormat: ['.2'],
      calculationFieldsAdjustPct: false,
      styles: {
        themeScheme: 'beiLightTheme',
        colors: {
          defaultColor: '#002380',
          defaultStrokeColor: '#002380',
          defaultFillColor: '#002380',
          dimensionField: ['serieIndex'],
          dimensionFieldSortOrder: null,
          dimensionFieldCustomOrder: null,
          dimensionScaleMode: ['categorical'], // categorical, continous
          scaleType: ['scaleOrdinal'], // scaleLinear, scaleSequential, scaleTreshold, scaleOrdinal
          interpolator: null,
          scheme: ['#002380', '#1E91A6', '#75C7C3', '#A3E3C0', '#CFFCD1'],
          schemeType: 'colorArray' // colorArray, colorGradientArray
        },
        textures: {
          active: false,
          defaultTexture: ''
        }
      },
      spider: {
        includeOrigin: true,
        linearGridline: true,
        linearGridlineStyle: 'curveLinearClosed', // curveLinearClosed, curveCardinalClosed
        linearGridlineNumber: 5,
        linearAxis: true,
        linearAxisLabel: false,
        linearAxisPosition: 'background',
        linearAxisMinMaxOnDataset: true,
        linearAxisLabelFormat: null,
        linearAxisLabelTextAnchor: null,
        linearAxisLabelHPadding: 0,
        linearAxisLabelVPadding: 0,
        linearAxisMinMax: [1, 10],
        linearAxisMinMaxExtendFactor: null,
        area: {
          visible: true,
          opacity: 0.1
        },
        hPosition: 'center',
        vPosition: 'center',
        hPadding: 0,
        vPadding: 0,
        lineWidth: 4,
        lineDashArray: '0'
      },
      axis: {
        fontFamily: 'Montserrat',
        fontSize: '14px',
        fontWeight: '200',
        color: '#ffffff',
        altColor: '#000000',
        labelColor: '#65676a',
        tickSize: 0,
        padding: 0,
        lineWidth: 2
      },
      gridline: {
        dashArray: '0',
        width: 0.5,
        color: '#CDCDCD',
        altColor: '#000000',
        opacity: 0.8,
        fillOpacity: 0.2
      },
      marker: {
        visible: false,
        style: 'square', // circle, square
        r: 10,
        strokeColor: null,
        strokeWidth: 4,
        fillColor: '#FFFFFF'
      },
      title: {
        visible: true,
        text: null,
        hPosition: 'left',
        vPosition: 'top',
        hPadding: 20,
        vPadding: 10,
        alignment: 'center',
        fontFamily: 'Montserrat',
        color: '#535353',
        fontSize: '13px',
        fontWeight: '300',
        textAnchor: 'middle',
        SVG: `<text style='text-anchor:start'><tspan dy='0.7em'>${title}</tspan></text>`
      },
      label: {
        visible: false
      },
      tooltip: {
        active: true,
        hPosition: 'mouse', // shape, mouse, fixe
        vPosition: 'mouse',
        hRelPosition: 'center',
        vRelPosition: 'up',
        lineSeparator: true,
        fontFamily: 'Montserrat',
        padding: 10,
        color: '#535353', // '#FFFFFF'
        fontSize: '15px',
        fontWeight: '400',
        textAnchor: 'start',
        backgroundColor: '#ffffff', // '#535353',
        SVG:
          "<g><g><line x1='14' x2='14' y1='14' y2='60' style='stroke : #002380;stroke-width: 2' /></g><text x='10' y='14' dy='0.7em'><tspan x='25' y='20'>Investor : [investor]</tspan><tspan x='25' y='52'>Value : [strategyExecution]</tspan></text></g>",
        variableFormat: {
          date: { datatype: 'date', formatIn: '%d/%m/%y', formatOut: '%B %e' }
        },
        tooltipSpecificFn: null
      },
      animation: {
        active: false,
        duration: 600,
        delay: 0,
        incrementalDelay: 0,
        ease: 'easeCubic' // default : easeCubic, easeLinear, easeBounce, easeElastic, easeExp, easeCircle
      },
      events: {
        mouseover: true,
        click: false
      }
    },
    contextualProperties: {
      tagId: id,
      dataIn: data,
      dataOut: null,
      d3viz: {
        dom: { viz: null, gridline: null, plot: null, axis: null, title: null },
        axis: {
          x: null,
          y: null,
          x2: null,
          y2: null,
          color: null,
          texture: null
        },
        barchart: { bandwidth: null }
      }
    }
  };

  function test2(data, action, id, title) {
    widgetRender(widgetProperties_US342, action);
  }

  useEffect(() => {
    if (d3svg.current && data) {
      const cnt = data.length;
      if (cnt !== 0) {
        test2(data, 'init', id, title);
      }
    } else d3svg.current = true;
  }, [data, id, test2, title]);

  const handleChangeChart = (e, v) => {
    updateChart(widgetProperties_US342, filterObject(listOfDatesByDay()[v]));
  };

  return (
    <>
      <div
        ref={d3svg}
        className="bar-chart-container"
        id={id}
        role="img"
        style={{ position: 'relative', width: '400px', height: '400px' }}>
        <SliderComponent handleChange={handleChangeChart} />
        {loading && (
          <h6 style={{ color: '#002380' }}>
            <LinearProgress />
          </h6>
        )}
        {error && <h4 style={{ color: 'red', fontSize: 14 }}>{error}</h4>}
      </div>
    </>
  );
};

export default ChartStrategyExec;

// style={{ pointerEvents: 'all', width: '100%', height: '100%' }}
